<template>
  <div class='table-box'>
    <global-tag>
      <el-form label-width='90px' :model='formData'>
        <el-row>
          <el-col :span='5'>
            <el-form-item label='姓名：'>
              <el-input v-model='formData.name' clearable placeholder='请输入'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='5'>
            <el-form-item label='手机号：'>
              <el-input v-model='formData.phone' clearable placeholder='请输入'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='5'>
            <el-form-item label='模版code：'>
              <el-input v-model='formData.templateCode' clearable placeholder='请输入'></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='5'>
            <el-form-item label='短信内容：'>
                <el-input
                v-model='formData.msgContent'
                clearable
                placeholder='请输入'
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span='5'>
            <el-form-item label='发送状态：'>
              <el-select v-model='formData.sendStatus' placeholder='请选择'>
                <el-option label='等待回执' value='1'></el-option>
                <el-option label='发送失败' value='2'></el-option>
                <el-option label='发送成功' value='3'></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='6' :offset='1'>
            <el-button type='primary' class='searchBtns' @click='getTableData'>查询
            </el-button>
            <el-button type="info" icon="el-icon-delete" @click="resert">清除条件
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </global-tag>
    <div>
      <el-table :data='tableData' border style='width: 100%'
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }">
        <el-table-column width='60' type='index' label='序号' show-overflow-tooltip align='center'></el-table-column>
        <el-table-column prop='name' show-overflow-tooltip label='姓名' align='center' width="90"></el-table-column>
        <!-- <el-table-column
          prop='extNum'
          show-overflow-tooltip
          label='身份证号'
          align='center'
        ></el-table-column> -->
        <el-table-column prop='phone' show-overflow-tooltip label='手机号' align='center' width="100"></el-table-column>
        <el-table-column prop='sendTime' show-overflow-tooltip label='发送时间' align='center' width="138">
        </el-table-column>
        <el-table-column prop='templateCode' show-overflow-tooltip label='短信模版code'
          align='center' width="130"></el-table-column>
        <el-table-column prop='msgContent' show-overflow-tooltip label='短信内容' align='center' min-width="220"></el-table-column>
        <el-table-column prop='sendStatus' label='状态' align='center' width="100">
          <template slot-scope='scope'>
            <span v-if="scope.row.sendStatus == '1'">等待回执</span>
            <span v-if="scope.row.sendStatus == '2'">发送失败</span>
            <span v-if="scope.row.sendStatus == '3'">发送成功</span>
          </template>
        </el-table-column>
        <el-table-column align='center' prop='failReason' show-overflow-tooltip label='失败原因'>
        </el-table-column>
        <!-- <el-table-column label='操作' align='center' width='150'>
          <template slot-scope='scope'>
            <el-button
              v-if='scope.row.issummary != 1'
              type='text'
              @click='see(scope.row.callID, scope.row)'
            >查看
            </el-button>
            <el-button
              type='text'
              @click='see(scope.row)'
              v-if="scope.row.connectFlag == '1'"
            >修改
            </el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination style='margin-top: 15px' background @size-change='handleSizeChange'
        @current-change='handleCurrentChange' :current-page='pageConfig.pageNo' :page-sizes='[5, 10, 20, 50]'
        :page-size='pageConfig.pageSize' layout='total, sizes, prev, pager, next, jumper' :total='pageConfig.total'>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request.js'
import { post } from '@/api/requrestHttp'
import headLine from '../components/headline'

export default {
  components: {
    headLine
  },
  data() {
    return {
      formData: {
        name: '',
        phone: '',
        templateCode: '',
         msgContent:'',
        sendStatus: ''
      },
      tableData: [],
      dialogFormVisible: false,
      pageConfig: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      addForm: {}
    }
  },
  created() {
    this.getTableData()
  },
  watch: {
  },
  methods: {
    see() {

    },
    resert(){
      this.formData={
        name: '',
        phone: '',
        templateCode: '',
         msgContent:'',
        sendStatus: ''
      }
      this.getTableData()
    },
    onDialogClose() {
      this.dialogFormVisible = false
    },
    summerSubmit() {

    },
    // 分页
    handleSizeChange(val) {
      this.pageConfig.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
    getTableData(params = {}) {
      this.$http
        .request({
          url: '/jjyl/admin/msg/record/findList',
          method: 'POST',
          data: {
            pageNo: this.pageConfig.pageNo,
            pageSize: this.pageConfig.pageSize,
            name: this.formData.name,
            phone: this.formData.phone,
            templateCode: this.formData.templateCode,
            msgContent: this.formData.msgContent,
            sendStatus: this.formData.sendStatus
          }
        })
        .then((res) => {
          if (res.code === 200 && res.content) {
            const arr = res.content.list || []
            this.tableData = arr
            this.pageConfig.total = res.content.count || 0
          } else {
            this.tableData = []
            this.pageConfig.total = 0
          }
        })
    }
  }
}
</script>

<style lang='less' scoped>
/deep/.cell.el-tooltip{
  white-space: wrap;
}
.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}
</style>
